import apiClient from '../../../lib/client';

/**
 * Authentication API functions
 */

export const authAPI = {
  // Register new user
  register: async (userData) => {
    const { data } = await apiClient.post('/auth/register', userData);
    return data;
  },

  // Login with email and password
  login: async (credentials) => {
    const { data } = await apiClient.post('/auth/login', credentials);
    return data;
  },

  // Logout (revoke refresh token)
  logout: async () => {
    const { data } = await apiClient.post('/auth/logout');
    return data;
  },

  // Refresh access token
  refresh: async () => {
    const { data } = await apiClient.post('/auth/refresh');
    return data;
  },

  // Verify email with token
  verifyEmail: async (token) => {
    const { data } = await apiClient.get(`/auth/verify-email?token=${token}`);
    return data;
  },

  // Request password reset
  forgotPassword: async (email) => {
    const { data } = await apiClient.post('/auth/forgot-password', { email });
    return data;
  },

  // Reset password with token
  resetPassword: async (token, newPassword) => {
    const { data } = await apiClient.post('/auth/reset-password', {
      token,
      newPassword,
    });
    return data;
  },

  // Change password (authenticated)
  changePassword: async (currentPassword, newPassword) => {
    const { data } = await apiClient.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return data;
  },

  // Create a temporary anonymous session for guest checkout
  createAnonymousSession: async () => {
    const { data } = await apiClient.post('/auth/anonymous-session');
    return data;
  },

  // Upgrade an anonymous session to a full account
  upgradeAnonymousSession: async (userData) => {
    const { data } = await apiClient.post('/auth/upgrade-anonymous-session', userData);
    return data;
  },
};
